import { render, staticRenderFns } from "./PublicGameEditor.vue?vue&type=template&id=41885f20"
import script from "./PublicGameEditor.vue?vue&type=script&lang=js"
export * from "./PublicGameEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports